// extracted by mini-css-extract-plugin
export default {"content":"RerollSelect_content__tPeVe","leftSection":"RerollSelect_leftSection__YnGLG","rightSection":"RerollSelect_rightSection__aYC7q","infoBlock":"RerollSelect_infoBlock__8h-Ng"};